import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getActiveLanguage } from 'react-localize-redux';

import './cookiepolicy.scss';
import CookiePolicyHtmlIt from './../../translations/shared/cookie_policy/cookie_policy_it.html';
import CookiePolicyHtmlEn from './../../translations/shared/cookie_policy/cookie_policy_en.html';

class CookiePolicy extends React.Component {

  constructor(props) {
    super(props);

    this.selectCookieHtmlContent = this.selectCookieHtmlContent.bind(this);
  }

  /* Methods */
  selectCookieHtmlContent() {
    switch (this.props.match.params.lang || this.props.currentLanguage) {
      case 'it':
        return CookiePolicyHtmlIt;
      case 'en':
        return CookiePolicyHtmlEn;
      default:
        return CookiePolicyHtmlEn;
    }
  }

  /* Lifecycle */
  render() {
    return (
      <Grid className="cookiepolicy-component">
        <Row>
          <Col xs={8} xsOffset={2}>
            <div dangerouslySetInnerHTML={{__html: this.selectCookieHtmlContent()}}/>
            <br/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

CookiePolicy.displayName = 'PagesCookiePolicy';
CookiePolicy.propTypes = {};
CookiePolicy.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    currentLanguage: getActiveLanguage(state.locale).code
  };
};

export default connect(mapStateToProps)(CookiePolicy);



// WEBPACK FOOTER //
// ./components/pages/CookiePolicy.js